/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 18:40:39
 */ 
import {mainEn} from "./main/mainEn.js";
import {oneTypeDetailEn} from "./oneTypeDetail/oneTypeDetailEn.js";
import {serviceDetailEn} from "./serviceDetail/serviceDetailEn.js";
import {serviceListEn} from "./serviceList/serviceListEn.js";
import {settleEn} from "./settle/indexEn.js";
import {consultationOrderDetailEn} from "./consultationOrderDetail/indexEn.js";
import {expertEn} from "./expert/indexEn.js";
import {InquirySheetDetailsEn} from "./InquirySheetDetails/indexEn.js";
import {expertStepEn} from "./expertStep/indexEn.js";
import {trainListEn} from "./trainList/indexEn.js";
import {trainHomeEn} from "./trainHome/indexEn.js";
import {trainVipEn} from "./trainVip/indexEn.js";
import {trainViewEn} from "./trainView/indexEn.js";
import {trainBuyingEn} from "./trainBuying/indexEn.js";
import {settleStepEn} from "./settleStep/indexEn.js";
import {expertListEn} from "./expertList/indexEn.js";
import {expertBuyOrderEn} from "./expertBuyOrder/indexEn.js";
import {expertPayOrderEn} from "./expertPayOrder/indexEn.js";
import {expertConsultationChatEn} from "./expertConsultationChat/indexEn";
import {fillapplicationEn} from "./selfHelpFillapplication/indexEn";
import {paymentEn} from './payment/indexEn';
import {registerEn} from "./register/indexEn";
import {channelEn} from "./channel/channelEn";
import {databaseEn} from "./database/indexEn";


export const homeEn = {
    mainLang:mainEn,
    oneTypeDetailLang:oneTypeDetailEn,
    serviceDetailLang:serviceDetailEn,
    serviceListLang: serviceListEn,
    settleHomeLang:settleEn,
    consultationOrderDetailLang:consultationOrderDetailEn,
    expertLang:expertEn,
    expertStepLang:expertStepEn,
    InquirySheetDetailsLang: InquirySheetDetailsEn,
    trainListLang:trainListEn,
    trainHomeLang:trainHomeEn,
    trainVipLang:trainVipEn,
    trainViewLang:trainViewEn,
    trainBuyingLang:trainBuyingEn,
    settleStepLang:settleStepEn,
    expertListLang:expertListEn,
    expertBuyOrderLang:expertBuyOrderEn,
    expertPayOrderLang:expertPayOrderEn,
    expertConsultationChatLang:expertConsultationChatEn,
    fillapplicationLang:fillapplicationEn,
    paymentLang:paymentEn,
    registerLang:registerEn,
    channelLang:channelEn,
    databaseLang:databaseEn
}


// WEBPACK FOOTER //
// ./src/lang/home/homeEn.js